import styled from "styled-components"

export const Container= styled.div`
    max-width: 900px;
    width: 100%;
    height: auto;
    margin-right: auto;
    margin-left: auto;
    @media screen and (max-width:1300px){
      padding: 0px 50px 0px 50px ;
    } 
    @media screen and (max-width:600px){
      padding: 0px 10px 0px 10px ;
      width:100% ;
    } 
    
`